export default () => ({
    activeTab: 'panel-1',
    tabIds: ['panel-1', 'panel-2', 'panel-3'],

    /* init() {
        const mq = window.matchMedia('(max-width: 640px)');
        this.isSmallScreen = mq.matches;

        const updateScreenState = (e) => {
            this.isSmallScreen = e.matches;
        };

        if (mq.addEventListener) {
            mq.addEventListener('change', updateScreenState);
        } else {
            mq.addListener(updateScreenState);
        }
    }, */

    setTab(panelId) {
        this.activeTab = panelId;
    },

    focusTab(index) {
        const ref = this.$refs[`tab${index}`];
        if (ref) ref.focus();
    },

    onKeydown(event, currentIndex) {
        const lastIndex = this.tabIds.length - 1;
        let nextIndex = null;

        const prevKey = 'ArrowLeft';
        const nextKey = 'ArrowRight';

        switch (event.key) {
            case prevKey:
                event.preventDefault();
                nextIndex = currentIndex === 0 ? lastIndex : currentIndex - 1;
                break;

            case nextKey:
                event.preventDefault();
                nextIndex = currentIndex === lastIndex ? 0 : currentIndex + 1;
                break;

            case 'Home':
                event.preventDefault();
                nextIndex = 0;
                break;

            case 'End':
                event.preventDefault();
                nextIndex = lastIndex;
                break;

            case 'Enter':
            case ' ':
                event.preventDefault();
                this.setTab(this.tabIds[currentIndex]);
                return;
        }

        if (nextIndex !== null) {
            this.setTab(this.tabIds[nextIndex]);
            this.focusTab(nextIndex);
        }
    }
});
